import { render, staticRenderFns } from "./starDetail.vue?vue&type=template&id=5bdb3a5b&scoped=true"
import script from "./starDetail.vue?vue&type=script&lang=js"
export * from "./starDetail.vue?vue&type=script&lang=js"
import style0 from "./starDetail.vue?vue&type=style&index=0&id=5bdb3a5b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdb3a5b",
  null
  
)

export default component.exports